<template>
  <sistema>
    <div>
      <kanban-orcamento :idOrcamento="idOrcamento" :isNew="isNew" />
    </div>
  </sistema>
</template>

<script lang="ts">
import { Options, Vue } from "vue-class-component";
import KanbanOrcamento from "../../components/orcamento/KanbanOrcamento.vue";

@Options({
  props: {
    isNew: Boolean,
    idOrcamento: Number
  },
  components: {
    KanbanOrcamento
  }
})
export default class Orcamento extends Vue {
  isNew?: boolean;
  idOrcamento?: number;
}
</script>

<style scoped lang="scss"></style>
